import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IArticle } from '../models/IArticle.type';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DataService {
    private baseUrl = `${environment.baseUrl}${environment.api.articles}`;
    private baseArticlesBody = `${environment.baseUrl}${environment.api.articlesBody}`;
    private baseGuidesUrl = `${environment.baseUrl}${environment.api.guides}`;
    private baseGuidesBody = `${environment.baseUrl}${environment.api.guidesBody}`;

    private headers = new Headers();
    
    constructor(private http: HttpClient){

        this.headers = new Headers();
        this.headers.set('Access-Control-Allow-Origin', '*');
        this.headers.set('Access-Control-Allow-Headers', 'Content-Type, application/json');
        this.headers.set('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
    }
    
    //List of Articles
    getArticles(): Observable<any>{
        return this.http.get<any>(`${this.baseUrl}`);
    }

    //Single Article By ID
    getArticle(id: number): Observable<any>{
        return this.http.get<any>(this.baseArticlesBody + '/' + id);
    }

    //Insert Article
    postArticle(title: string, description: string, tags:any, environment: string, category: string) {

        const headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' })
        };

        const article:IArticle = {
            title: title,
            description: description,
            tags: tags,
            environment: environment, 
            category: category
        };

        return this.http.post<any>(this.baseUrl, article, headers)
                .pipe(catchError(this.handleError));
           
    }

    putArticle(id: number, title: string, description: string, article_id: number, environment: string, category: string) {

        const headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' })
        };

        const article:IArticle = {
            id: id,
            title: title,
            description: description,
            article_id: article_id,
            environment: environment, 
            category: category
        };

        return this.http.put<any>(this.baseUrl + '/' + id, article, headers)
                .pipe(catchError(this.handleError));
           
    }

    deleteArticle(id: number) {
        return this.http.delete<IArticle>(this.baseUrl + '/' + id)
                .pipe(catchError(this.handleError));
           
    }

    //List of Guides
    getGuides(): Observable<any>{
        return this.http.get<any>(`${this.baseGuidesUrl}`);
    }

    //Single Guide By ID
    getGuide(id: number): Observable<any>{
        return this.http.get<any>(this.baseGuidesBody + '/' + id);
    }

    //Insert Article
    postGuide(title: string, description: string) {

        const headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' })
        };

        const article:IArticle = {
            title: title,
            description: description,
            tags: null
        };

        return this.http.post<any>(this.baseGuidesUrl, article, headers)
                .pipe(catchError(this.handleError));
           
    }

    putGuide(id: number, title: string, guideId: number, description: string) {

        const headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' })
        };

        const article:IArticle = {
            id: id,
            title: title,
            article_id: guideId,
            description: description, 
            tags: null
        };

        return this.http.put<any>(this.baseGuidesUrl + '/' + id, article, headers)
                .pipe(catchError(this.handleError));
           
    }

    deleteGuide(id: number) {

        const headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' })
        };

        return this.http.delete<IArticle>(this.baseGuidesUrl + '/' + id, headers)
                .pipe(catchError(this.handleError));
           
    }

    handleError(error: HttpErrorResponse){
        return throwError(error);
    }

}